$(function(){
    header();
    sliders();
    filters();
    deleteAddress();
    editAddress();
    stores();
    buttons();
    countryModal();
    zoom();
    ictstores();

    $('[data-modal-show]').parents('.modal').show();

    footerNewsletterForm('#footer-desktop-newsletter');
    footerNewsletterForm('#footer-mobile-newsletter');
    loginForm('#login-form');
    recoverForm('#recover-form');
    registerForm('#register-form');
    newAddressForm('#new-address-collapse');
    resetForm('#reset-form');
    storeForm('#store-form');
    contactForm('#contact-form');
    productForm('#notify-form');
});

function buttons(){
    $('[data-text-hover]').each(function(){
        var txt = $(this).text();
        $(this).on('mouseover', function(){
            $(this).text($(this).attr('data-text-hover'));
        }).on('mouseleave', function(){
            $(this).text(txt);
        });
    });
}

function header(){
    var h = $('.site_header');
    if($('#home-slider').length || $('.banner').length){
        $(window).scroll(function (event) {
            var scroll = $(window).scrollTop();
            if(scroll > 10){
                if(!$(h).hasClass('header-scroll'))
                    $(h).addClass('header-scroll');
            }
            else{
                if($(h).hasClass('header-scroll'))
                    $(h).removeClass('header-scroll');
            }
        });
    }
    else{
        $(h).addClass('header-scroll');
    }

    $('[data-menu]').each(function(){
        var menu = $(this).attr('data-menu');

        $(this).on('click', function(){
            $('body').toggleClass('menu-mobile');
        });
    });

    $('.dropdown [data-bs-toggle="collapse"]').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var coll = $(this).parent().find('.collapse');
        if($(coll).hasClass('show')){
            $(coll).collapse('hide');
        }
        else{
            $(coll).collapse('show');
        }
    });

    $('.language-select input').on('change', function(){
        $(this).parents('form').submit();
    });
}

function sliders(){
    const homeSlider = new Swiper('#home-slider', {
        direction: 'horizontal',
        loop: false,
      
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
    });

    const homeBottomSlider = new Swiper('#home-bottom-slider', {
        slidesPerView: 1,
        spaceBetween: 60,
        breakpoints: {
            640: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 4,
            }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
    });

    const productSlider = new Swiper("#product-slider", {
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
    });
}

function filters(){
    $('[data-filter-url]').each(function(){
        $(this).on('change', function(){
            location.href = $(this).attr('data-filter-url');
        });
    });

    $('[data-filters-toggle]').each(function(){
        var menu = $(this).attr('data-filters-toggle');

        $(this).on('click', function(){
            $('body').toggleClass('filters-mobile');
        });
    });
}

function deleteAddress(){
    $('[data-delete-address]').on('click', function(e){
        e.preventDefault();
        var target = $(this).attr('data-delete-address');
        var myModal = new bootstrap.Modal(document.getElementById('delete-address-confirm'));
        myModal.show();
        $('#delete-address-confirm [data-confirm]').off().on('click', function(){
            Shopify.postLink(target, {
                parameters: { _method: 'delete' }
            });
        });
    });
}

function editAddress(){
    var els = [];
    $('[data-address-edit-link]').on('click', function(e){
        e.preventDefault();
        var id = $(this).attr('href');
        $(els).each(function(){
            this.hide();
        });
        var bsCollapse = new bootstrap.Collapse($(id));
        bsCollapse.show();
    });

    $('[data-address-edit]').each(function(){
        els[els.length] = new bootstrap.Collapse(this, {toggle: false});
        editAddressForm($(this).attr('id'));
    });
}

function stores(){
    $('[data-store-map]').on('click', function(e){
        e.preventDefault();
        $('#store-map').attr('src', $(this).attr('data-store-map'));
        $('#store-name strong').html($(this).attr('data-store-name'));
        $('#store-description').html($(this).attr('data-store-description'));
        $('[data-store-map]').removeClass('text-bold');
        $(this).addClass('text-bold');
    });
}

function countryModal(){
    $.getJSON('https://geolocation-db.com/json/7733a990-ebd4-11ea-b9a6-2955706ddbf3', function(result) {  
        var codes = ['JP', 'NZ', 'AU', 'HK', 'TW', 'CN', 'KR', 'RU', 'UA'];
        var red = false;
        $(codes).each(function(){
            if(result.country_code == this){
                red = true;
            }
        });
        if(red){ 
            location.href = 'http://transit-official.com/';
        }
    });
}

function footerNewsletterForm(id){
    if($(id).length){
        var form = $(id);
        var emailInput = $(id+'-email');
        var privacyInput = $(id+'-privacy');
        var btn = $(form).find('[data-form-submit]');

        $(btn).on('click', function(e){
            vEmail = validateEmail();
            vPrivacy = validatePrivacy();
            if(vEmail === true && vPrivacy === true){
                $(form).submit();
            }
        });

        function validateEmail(){
            var valid = validEmail(emailInput);
            if(valid !== true){
                setInvalid(emailInput, valid);
            }
            else{
                setValid(emailInput);
            }
            return valid;
        }

        function validatePrivacy(){
            var valid = validCheckbox(privacyInput);
            if(valid !== true){
                setInvalid(privacyInput, valid);
            }
            else{
                setValid(privacyInput);
            }
            return valid;
        }

        $(form).find('input, textarea, select').on('focus', function(){
            setWriting(this);
        });

        $(emailInput).on('blur', validateEmail);
        $(privacyInput).on('change', validatePrivacy);
    }
}

function loginForm(id){
    if($(id).length){
        var form = $(id);
        var emailInput = $(id+'-email');
        var passwordInput = $(id+'-password');
        var btn = $(form).find('[data-form-submit]');

        $(btn).on('click', function(e){
            vEmail = validateEmail();
            vPassword = validatePassword();
            if(vEmail === true && vPassword === true){
                $(form).submit();
            }
        });

        function validateEmail(){
            var valid = validEmail(emailInput);
            if(valid !== true){
                setInvalid(emailInput, valid);
            }
            else{
                setValid(emailInput);
            }
            return valid;
        }

        function validatePassword(){
            var valid = validText(passwordInput);
            if(valid !== true){
                setInvalid(passwordInput, valid);
            }
            else{
                setValid(passwordInput);
            }
            return valid;
        }

        $(form).find('input, textarea, select').on('focus', function(){
            setWriting(this);
        });

        $(emailInput).on('blur', validateEmail);
        $(passwordInput).on('blur', validatePassword);
    }
}

function recoverForm(id){
    if($(id).length){
        var form = $(id);
        var emailInput = $(id+'-email');
        var btn = $(form).find('[data-form-submit]');

        $(btn).on('click', function(e){
            vEmail = validateEmail();
            if(vEmail === true){
                $(form).submit();
            }
        });

        function validateEmail(){
            var valid = validEmail(emailInput);
            if(valid !== true){
                setInvalid(emailInput, valid);
            }
            else{
                setValid(emailInput);
            }
            return valid;
        }

        $(form).find('input, textarea, select').on('focus', function(){
            setWriting(this);
        });

        $(emailInput).on('blur', validateEmail);
    }
}

function registerForm(id){
    if($(id).length){
        var form = $(id);
        var nameInput = $(id+'-firstname');
        var surnameInput = $(id+'-lastname');
        var emailInput = $(id+'-email');
        var passwordInput = $(id+'-password');
        var btn = $(form).find('[data-form-submit]');

        $(btn).on('click', function(e){
            vName = validateName();
            vSurname = validateSurname();
            vEmail = validateEmail();
            vPassword = validatePassword();
            if(vEmail === true && vPassword === true && vName === true && vSurname === true){
                $(form).submit();
            }
        });

        function validateEmail(){
            var valid = validEmail(emailInput);
            if(valid !== true){
                setInvalid(emailInput, valid);
            }
            else{
                setValid(emailInput);
            }
            return valid;
        }

        function validatePassword(){
            var valid = validPassword(passwordInput);
            if(valid !== true){
                setInvalid(passwordInput, valid);
            }
            else{
                setValid(passwordInput);
            }
            return valid;
        }

        function validateName(){
            var valid = validText(nameInput);
            if(valid !== true){
                setInvalid(nameInput, valid);
            }
            else{
                setValid(nameInput);
            }
            return valid;
        }

        function validateSurname(){
            var valid = validText(surnameInput);
            if(valid !== true){
                setInvalid(surnameInput, valid);
            }
            else{
                setValid(surnameInput);
            }
            return valid;
        }

        $(form).find('input, textarea, select').on('focus', function(){
            setWriting(this);
        });

        $(nameInput).on('blur', validateName);
        $(surnameInput).on('blur', validateSurname);
        $(emailInput).on('blur', validateEmail);
        $(passwordInput).on('blur', validatePassword);
    }
}

function resetForm(id){
    if($(id).length){
        var form = $(id);
        var passwordInput = $(id+'-password');
        var confirmInput = $(id+'-confirm');
        var btn = $(form).find('[data-form-submit]');

        $(btn).on('click', function(e){
            vPassword = validatePassword();
            vConfirm = validateConfirm();
            if(vPassword === true && vConfirm === true){
                $(form).submit();
            }
        });

        function validatePassword(){
            var valid = validPassword(passwordInput);
            if(valid !== true){
                setInvalid(passwordInput, valid);
            }
            else{
                setValid(passwordInput);
            }
            return valid;
        }

        function validateConfirm(){
            var valid = validConfirm(confirmInput, $(passwordInput).val());
            if(valid !== true){
                setInvalid(confirmInput, valid);
            }
            else{
                setValid(confirmInput);
            }
            return valid;
        }

        $(form).find('input, textarea, select').on('focus', function(){
            setWriting(this);
        });
        
        $(passwordInput).on('blur', validatePassword);
        $(confirmInput).on('blur', validateConfirm);
    }
}

function newAddressForm(id){
    if($(id).length > 0){
        var form = $(id).parents('form');
        var nameInput = $('#AddressFirstNameNew');
        var surnameInput = $('#AddressLastNameNew');
        var companyInput = $('#AddressCompanyNew');
        var address1Input = $('#AddressAddress1New');
        var address2Input = $('#AddressAddress2New');
        var cityInput = $('#AddressCityNew');
        var provinceInput = $('#AddressProvinceNew');
        var zipInput = $('#AddressZipNew');
        var countryInput = $('#AddressCountryNew');
        var phoneInput = $('#AddressPhoneNew');
        var btn = $(form).find('[data-form-submit]');

        $(btn).on('click', function(e){
            vName = validateName();
            vSurname = validateSurname();
            vCompany = validateCompany();
            vAddress1 = validateAddress1();
            vAddress2 = validateAddress2();
            vCity = validateCity();
            vProvince = validateProvince();
            vZip = validateZip();
            vCountry = validateCountry();
            vPhone = validatePhone();
            if(vName === true && vSurname === true && vCompany === true && vAddress1 === true && vAddress2 === true && vCity === true && vProvince === true && vZip === true && vCountry === true && vPhone === true){
                $(form).submit();
            }
        });

        if (Shopify) {
            new Shopify.CountryProvinceSelector(
              'AddressCountryNew',
              'AddressProvinceNew',
              {
                hideElement: 'AddressProvinceContainerNew'
              }
            );
          }

        function validateName(){
            var valid = validText(nameInput);
            if(valid !== true)
                setInvalid(nameInput, valid);
            else
                setValid(nameInput);
            return valid;
        }

        function validateSurname(){
            var valid = validText(surnameInput);
            if(valid !== true)
                setInvalid(surnameInput, valid);
            else
                setValid(surnameInput);
            return valid;
        }

        function validateCompany(){
            var valid = validText(companyInput);
            if(valid !== true)
                setInvalid(companyInput, valid);
            else
                setValid(companyInput);
            return valid;
        }

        function validateAddress1(){
            var valid = validText(address1Input);
            if(valid !== true)
                setInvalid(address1Input, valid);
            else
                setValid(address1Input);
            return valid;
        }

        function validateAddress2(){
            var valid = validText(address2Input);
            if(valid !== true)
                setInvalid(address2Input, valid);
            else
                setValid(address2Input);
            return valid;
        }

        function validateCity(){
            var valid = validText(cityInput);
            if(valid !== true)
                setInvalid(cityInput, valid);
            else
                setValid(cityInput);
            return valid;
        }

        function validateZip(){
            var valid = validZip(zipInput);
            if(valid !== true)
                setInvalid(zipInput, valid);
            else
                setValid(zipInput);
            return valid;
        }

        function validateProvince(){
            var valid = validText(provinceInput);
            if(valid !== true)
                setInvalid(provinceInput, valid);
            else
                setValid(provinceInput);
            return valid;
        }

        function validateCountry(){
            var valid = validText(countryInput);
            if(valid !== true)
                setInvalid(countryInput, valid);
            else
                setValid(countryInput);
            return valid;
        }

        function validatePhone(){
            var valid = validPhone(phoneInput);
            if(valid !== true)
                setInvalid(phoneInput, valid);
            else
                setValid(phoneInput);
            return valid;
        }

        $(form).find('input, textarea, select').on('focus', function(){
            setWriting(this);
        });

        $(nameInput).on('blur', validateName);
        $(surnameInput).on('blur', validateSurname);
        $(companyInput).on('blur', validateCompany);
        $(address1Input).on('blur', validateAddress1);
        $(address2Input).on('blur', validateAddress2);
        $(cityInput).on('blur', validateCity);
        $(provinceInput).on('change', validateProvince);
        $(zipInput).on('blur', validateZip);
        $(countryInput).on('change', validateCountry);
        $(phoneInput).on('blur', validatePhone);
    }
}

function editAddressForm(id){
    var form = $('#'+id).parents('form');
        var app = $(form).attr('id').split('_');
        app = app[app.length-1];
        var nameInput = $('#AddressFirstName_'+app);
        var surnameInput = $('#AddressLastName_'+app);
        var companyInput = $('#AddressCompany_'+app);
        var address1Input = $('#AddressAddress1_'+app);
        var address2Input = $('#AddressAddress2_'+app);
        var cityInput = $('#AddressCity_'+app);
        var provinceInput = $('#AddressProvince_'+app);
        var zipInput = $('#AddressZip_'+app);
        var countryInput = $('#AddressCountry_'+app);
        var phoneInput = $('#AddressPhone_'+app);
        var btn = $(form).find('[data-form-submit]');

        $(btn).on('click', function(e){
            vName = validateName();
            vSurname = validateSurname();
            vCompany = validateCompany();
            vAddress1 = validateAddress1();
            vAddress2 = validateAddress2();
            vCity = validateCity();
            vProvince = validateProvince();
            vZip = validateZip();
            vCountry = validateCountry();
            vPhone = validatePhone();
            if(vName === true && vSurname === true && vCompany === true && vAddress1 === true && vAddress2 === true && vCity === true && vProvince === true && vZip === true && vCountry === true && vPhone === true){
                $(form).submit();
            }
        });

        if (Shopify) {
            new Shopify.CountryProvinceSelector(
              'AddressCountry_'+app,
              'AddressProvince_'+app,
              {
                hideElement: 'AddressProvinceContainer_'+app
              }
            );
            $(provinceInput).val($(provinceInput).attr('data-value'));
          }

        function validateName(){
            var valid = validText(nameInput);
            if(valid !== true)
                setInvalid(nameInput, valid);
            else
                setValid(nameInput);
            return valid;
        }

        function validateSurname(){
            var valid = validText(surnameInput);
            if(valid !== true)
                setInvalid(surnameInput, valid);
            else
                setValid(surnameInput);
            return valid;
        }

        function validateCompany(){
            var valid = validText(companyInput);
            if(valid !== true)
                setInvalid(companyInput, valid);
            else
                setValid(companyInput);
            return valid;
        }

        function validateAddress1(){
            var valid = validText(address1Input);
            if(valid !== true)
                setInvalid(address1Input, valid);
            else
                setValid(address1Input);
            return valid;
        }

        function validateAddress2(){
            var valid = validText(address2Input);
            if(valid !== true)
                setInvalid(address2Input, valid);
            else
                setValid(address2Input);
            return valid;
        }

        function validateCity(){
            var valid = validText(cityInput);
            if(valid !== true)
                setInvalid(cityInput, valid);
            else
                setValid(cityInput);
            return valid;
        }

        function validateZip(){
            var valid = validZip(zipInput);
            if(valid !== true)
                setInvalid(zipInput, valid);
            else
                setValid(zipInput);
            return valid;
        }

        function validateProvince(){
            var valid = validText(provinceInput);
            if(valid !== true)
                setInvalid(provinceInput, valid);
            else
                setValid(provinceInput);
            return valid;
        }

        function validateCountry(){
            var valid = validText(countryInput);
            if(valid !== true)
                setInvalid(countryInput, valid);
            else
                setValid(countryInput);
            return valid;
        }

        function validatePhone(){
            var valid = validPhone(phoneInput);
            if(valid !== true)
                setInvalid(phoneInput, valid);
            else
                setValid(phoneInput);
            return valid;
        }

        $(form).find('input, textarea, select').on('focus', function(){
            setWriting(this);
        });

        $(nameInput).on('blur', validateName);
        $(surnameInput).on('blur', validateSurname);
        $(companyInput).on('blur', validateCompany);
        $(address1Input).on('blur', validateAddress1);
        $(address2Input).on('blur', validateAddress2);
        $(cityInput).on('blur', validateCity);
        $(provinceInput).on('change', validateProvince);
        $(zipInput).on('blur', validateZip);
        $(countryInput).on('change', validateCountry);
        $(phoneInput).on('blur', validatePhone);
}

function storeForm(id){
    if($(id).length){
        var form = $(id);
        var emailInput = $(id+'-email');
        var countryInput = $(id+'-country');
        var cityInput = $(id+'-city');
        var zipInput = $(id+'-zip');
        var privacyInput = $(id+'-privacy');
        var bodyInput = $(id+'-body');
        var btn = $(form).find('[data-form-submit]');

        $(btn).on('click', function(e){
            vEmail = validateEmail();
            vCountry = validateCountry();
            vCity = validateCity();
            vPrivacy = validatePrivacy();
            vZip = validateZip();
            if(vEmail === true && vCity === true && vPrivacy === true && vCountry === true && vZip === true){
                $(bodyInput).val('Paese: '+$(countryInput).val()+', Città: '+$(cityInput).val()+', ZIP: '+$(zipInput).val());
                $(form).submit();
            }
        });

        function validateEmail(){
            var valid = validEmail(emailInput);
            if(valid !== true){
                setInvalid(emailInput, valid);
            }
            else{
                setValid(emailInput);
            }
            return valid;
        }

        function validateCountry(){
            var valid = validText(countryInput);
            if(valid !== true){
                setInvalid(countryInput, valid);
            }
            else{
                setValid(countryInput);
            }
            return valid;
        }

        function validateCity(){
            var valid = validText(cityInput);
            if(valid !== true){
                setInvalid(cityInput, valid);
            }
            else{
                setValid(cityInput);
            }
            return valid;
        }

        function validateZip(){
            var valid = validZip(zipInput);
            if(valid !== true)
                setInvalid(zipInput, valid);
            else
                setValid(zipInput);
            return valid;
        }

        function validatePrivacy(){
            var valid = validCheckbox(privacyInput);
            if(valid !== true){
                setInvalid(privacyInput, valid);
            }
            else{
                setValid(privacyInput);
            }
            return valid;
        }

        $(form).find('input, textarea, select').on('focus', function(){
            setWriting(this);
        });

        $(emailInput).on('blur', validateEmail);
        $(countryInput).on('blur', validateCountry);
        $(cityInput).on('blur', validateCity);
        $(zipInput).on('blur', validateZip);
        $(privacyInput).on('change', validatePrivacy);
    }
}

function contactForm(id){
    if($(id).length){
        var form = $(id);
        var nameInput = $(id+'-name');
        var emailInput = $(id+'-email');
        var phoneInput = $(id+'-phone');
        var messageInput = $(id+'-message');
        var privacyInput = $(id+'-privacy');
        var btn = $(form).find('[data-form-submit]');

        $(btn).on('click', function(e){
            vName = validateName();
            vEmail = validateEmail();
            vPhone = validatePhone();
            vMessage = validateMessage();
            vPrivacy = validatePrivacy();
            if(vEmail === true && vPhone === true && vName === true && vMessage === true && vPrivacy === true){
                $(form).submit();
            }
        });

        function validateEmail(){
            var valid = validEmail(emailInput);
            if(valid !== true){
                setInvalid(emailInput, valid);
            }
            else{
                setValid(emailInput);
            }
            return valid;
        }

        function validatePhone(){
            var valid = validPhone(phoneInput);
            if(valid !== true){
                setInvalid(phoneInput, valid);
            }
            else{
                setValid(phoneInput);
            }
            return valid;
        }

        function validateName(){
            var valid = validText(nameInput);
            if(valid !== true){
                setInvalid(nameInput, valid);
            }
            else{
                setValid(nameInput);
            }
            return valid;
        }

        function validateMessage(){
            var valid = validText(messageInput);
            if(valid !== true){
                setInvalid(messageInput, valid);
            }
            else{
                setValid(messageInput);
            }
            return valid;
        }

        function validatePrivacy(){
            var valid = validCheckbox(privacyInput);
            if(valid !== true){
                setInvalid(privacyInput, valid);
            }
            else{
                setValid(privacyInput);
            }
            return valid;
        }

        $(form).find('input, textarea, select').on('focus', function(){
            setWriting(this);
        });

        $(nameInput).on('blur', validateName);
        $(phoneInput).on('blur', validatePhone);
        $(emailInput).on('blur', validateEmail);
        $(messageInput).on('blur', validateMessage);
        $(privacyInput).on('change', validatePrivacy);
    }
}

function productForm(id){
    if($(id).length){
        var form = $(id);
        var emailInput = $(id+'-email');
        var btn = $(form).find('[data-form-submit]');

        $(btn).on('click', function(e){
            vEmail = validateEmail();
            if(vEmail === true){
                $(form).submit();
            }
        });

        function validateEmail(){
            var valid = validEmail(emailInput);
            if(valid !== true){
                setInvalid(emailInput, valid);
            }
            else{
                setValid(emailInput);
            }
            return valid;
        }

        $(form).find('input, textarea, select').on('focus', function(){
            setWriting(this);
        });

        $(emailInput).on('blur', validateEmail);
    }
}

function setWriting(input){
    var par = $(input).parents('[data-input-parent]');
    var feed = $(par).find('.invalid-feedback');
    $(par).removeClass('has-validation');
    $(input).removeClass('is-invalid').removeClass('is-valid');
    $(feed).text("");
}

function setValid(input){
    var par = $(input).parents('[data-input-parent]');
    var feed = $(par).find('.invalid-feedback');
    $(par).removeClass('has-validation');
    $(input).removeClass('is-invalid');
    if($(input).val() !== undefined){
        $(input).addClass('is-valid');
    }
    $(feed).text("");
}

function setInvalid(input, message){
    var par = $(input).parents('[data-input-parent]');
    var feed = $(par).find('.invalid-feedback');
    $(par).addClass('has-validation');
    $(input).addClass('is-invalid').removeClass('is-valid');
    $(feed).text(message);
}

function validCheckbox(input){
    var isValid = true;
    if($(input).attr('required') !== undefined && !$(input).is(':checked')){
        isValid = $(input).attr('data-form-empty-error');
    }
    return isValid;
}

function validEmail(input){
    var value = $(input).val();
    var isValid = true;
    if($(input).attr('required') !== undefined && (value.length <= 0 || value == undefined)){
        isValid = $(input).attr('data-form-empty-error');
    }
    else if(!isEmail(value)){
        isValid = $(input).attr('data-form-email-error');
    }
    return isValid;
}

function validText(input){
    var value = $(input).val();
    var isValid = true;
    if($(input).attr('required') !== undefined && (value.length <= 0 || value == undefined)){
        isValid = $(input).attr('data-form-empty-error');
    }
    return isValid;
}

function validZip(input){
    var value = $(input).val();
    var isValid = true;
    if($(input).attr('required') !== undefined && (value.length <= 0 || value == undefined)){
        isValid = $(input).attr('data-form-empty-error');
    }
    else if(!/^\d{5}(?:[-\s]\d{4})?$/.test(value)){
        isValid = $(input).attr('data-form-format-error');
    }
    return isValid;
}

function validPhone(input){
    var value = $(input).val();
    var isValid = true;
    if($(input).attr('required') !== undefined && (value.length <= 0 || value == undefined)){
        isValid = $(input).attr('data-form-empty-error');
    }
    else if(!/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value)){
        if(value.length > 0)
            isValid = $(input).attr('data-form-format-error');
    }
    return isValid;
}

function validPassword(input){
    var value = $(input).val();
    var isValid = true;
    if($(input).attr('required') !== undefined && (value.length <= 0 || value == undefined)){
        isValid = $(input).attr('data-form-empty-error');
    }
    else if(!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{6,}$/.test(value)){
        isValid = $(input).attr('data-form-newpassword-error');
    }
    return isValid;
}

function validConfirm(input, comp){
    var value = $(input).val();
    var isValid = true;
    if($(input).attr('required') !== undefined && (value.length <= 0 || value == undefined)){
        isValid = $(input).attr('data-form-empty-error');
    }
    else if(value.localeCompare(comp) != 0){
        isValid = $(input).attr('data-form-confirm-error');
    }
    return isValid;
}

function isEmail(email){
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function zoom(){
    $('[data-zoom]').on('click', function(){
        if(!$('#zoom').length){
            $('body').prepend('<img src="'+$(this).attr('data-zoom')+'" loading="lazy" id="zoom">');
            $('#zoom').on('click', function(){
                $(this).remove();
            });
        }
    });
}

// Accessibilita: Esc chiude menu e filtri mobile, focus nel menu all'apertura
document.addEventListener('keydown', function(e){ if (e.key !== 'Escape') return; var b = document.body; if (b.classList.contains('menu-mobile')) { b.classList.remove('menu-mobile'); var t = document.getElementById('AccessibleNav'); if (t) t.focus(); } if (b.classList.contains('filters-mobile')) { b.classList.remove('filters-mobile'); } });
document.addEventListener('click', function(e){ if (!e.target.closest || !e.target.closest('#AccessibleNav')) return; setTimeout(function(){ if (document.body.classList.contains('menu-mobile')) { var l = document.querySelector('#header-menu-mobile a, #header-menu-mobile button'); if (l) l.focus(); } }, 50); });